import { Controller } from '@hotwired/stimulus';
import { createEvent, isEnterKey, isEscapeKey, isSpaceKey } from '../utils';

let lastOpen = null;

function isWithinSelect(e) {
  let currentElement = e.target;

  while (currentElement) {
    if (currentElement.classList.contains('custom-select')) {
      return true;
    }

    currentElement = currentElement.parentElement;
  }

  return false;
}

export default class extends Controller {
  static targets = ['head', 'counter', 'dropdown', 'placeholder'];

  static values = {
    multiple: Boolean,
  };

  connect() {
    this.element.addEventListener('input', this._onChange.bind(this));

    this.headTarget.addEventListener('click', this.toggleOpen.bind(this));
    this.headTarget.addEventListener('keydown', this._handleHeadKeydown.bind(this));
    this.dropdownTarget.addEventListener('keydown', this._handleDropdownKeydown.bind(this));

    window.document.documentElement.addEventListener('click', this._handleGlobalClick.bind(this));
  }

  disconnect() {
    super.disconnect();

    if (lastOpen === this.element) {
      lastOpen = null;
    }
  }

  toggleOpen() {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  close() {
    if (!this.isOpen()) {
      return;
    }

    this.element.classList.remove('is-open');
    this.element.dispatchEvent(createEvent('custom-select:close'));
  }

  open() {
    if (this.isOpen()) {
      return;
    }

    if (lastOpen && lastOpen !== this.element) {
      this.application.getControllerForElementAndIdentifier(lastOpen, 'custom-select').close();
    }

    this.element.classList.add('is-open');
    this.element.dispatchEvent(createEvent('custom-select:open'));
    lastOpen = this.element;
  }

  isOpen() {
    return this.element.classList.contains('is-open');
  }

  _onChange() {
    if (this.multipleValue) {
      this._updateCounter();
    } else {
      this._updatePlaceholder();
      this.close();
    }
  }

  _updatePlaceholder() {
    for (const input of Array.from(this.element.querySelectorAll('input'))) {
      if (input.checked) {
        this.placeholderTarget.textContent = input.parentElement.textContent;
        break;
      }
    }
  }

  _updateCounter() {
    if (!this.counterTarget) {
      return;
    }

    let count = 0;

    this.element.querySelectorAll('input').forEach(input => {
      if (input.type === 'checkbox' && input.checked) {
        count++;
      }
    });

    this.counterTarget.textContent = count || '';
  }

  _handleGlobalClick(e) {
    if (!this.isOpen()) {
      return;
    }

    if (isWithinSelect(e)) {
      return;
    }

    this.close();
  }

  _handleHeadKeydown(e) {
    if (isEnterKey(e) || isSpaceKey(e)) {
      e.preventDefault();
      this.toggleOpen();
    }
  }

  _handleDropdownKeydown(e) {
    if (isEscapeKey(e)) {
      e.preventDefault();
      this.close();
      this.headTarget.focus();
    }
  }
}
